import React from 'react'
import InputCustom from 'components/Inputs'
import { CustomButton } from 'styles/global'
import { BannerWrapper } from '../style'
import { ApplicationState } from 'store'
import { useSelector } from 'react-redux'
import { LANDING_PAGE } from 'store/modules/landingPage/types'
import useRedux from 'hooks/useRedux'
import * as landingPageActions from 'store/modules/landingPage/actions'
import { maskCPF, removeMaskCPF } from 'util/masks'
import { schemaCpfLanding } from '../constants/schema'
import * as yup from 'yup'
import CPFJaCadastradoModal from 'views/produtos/components/modalCPF'

const Banner = () => {
  const { cpfLanding, cpfLandingInvalid, modalCpf } = useSelector<
    ApplicationState,
    LANDING_PAGE
  >((state) => state.landingPage)

  const { dispatch } = useRedux()

  function onChange(value: string) {
    dispatch(landingPageActions.setCpfLanding(value))
  }

  function onIniciar() {
    dispatch(landingPageActions.cleanCpfLandingInvalid())
    schemaCpfLanding
      .validate(
        {
          cpf: removeMaskCPF(cpfLanding)
        },
        { abortEarly: false }
      )
      .then(() => {
        dispatch(landingPageActions.iniciarSaga())
      })
      .catch((err) => {
        err.inner.forEach((e: yup.ValidationError) => {
          dispatch(
            landingPageActions.setCpfLandingInvalid({
              invalid: true,
              message: e.message
            })
          )
        })
      })
  }
  function onRedirectToLogin() {
    window.location.href = '/login'
  }

  return (
    <BannerWrapper>
      <div className="container container-banner">
        <div className="d-flex flex-column justify-content-center align-items-center gap-40 px-3 px-md-0">
          <div className="d-flex flex-column align-items-left">
            <h2>
              Seu crédito <span className="tag-Laranja">rápido</span>,{' '}
              <span className="tag-Laranja">seguro</span>
              <br /> e sem complicação.
            </h2>

            <span className="subtitle">
              Simule agora e tenha aprovação em minutos.
            </span>
          </div>
          <div className="d-flex flex-column flex-md-row align-items-center gap-4 w-100 px-3">
            <InputCustom
              id="iniciar-simulacao"
              className="input-cpf mobile-border"
              placeholder="Digite seu CPF"
              onChange={(e) => {
                onChange(maskCPF(e.target.value))
              }}
              value={cpfLanding}
              invalid={cpfLandingInvalid.invalid}
              errorMessage={cpfLandingInvalid.message}
              height={56}
              inputMode="numeric"
              pattern="[0-9]*"
            />

            <CustomButton
              background="var(--verde-riber)"
              onClick={onIniciar}
              borderRadius={50}
              height="56px"
              fontSize="1rem"
              width={300}
              className="simulation-button"
            >
              SIMULAR
            </CustomButton>
          </div>

          <div className="d-flex gap-2">
            <span className="tips">
              <img
                src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/home_2.png"
                width={30}
              />
              <span className="tips-text">Taxas reduzidas</span>
            </span>
            <span className="tips">
              <img
                src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/home_3.png"
                width={30}
              />
              <span className="tips-text">Liberação rápida</span>
            </span>
            <span className="tips">
              <img
                src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/home_4.png"
                width={30}
              />
              <span className="tips-text">100% seguro e online</span>
            </span>
          </div>
        </div>
        <div className="w-50 d-none d-xl-flex justify-content-end">
          <img
            src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/home_1.png"
            width={500}
          />
        </div>
      </div>
      <CPFJaCadastradoModal
        isOpen={modalCpf}
        toggle={() => dispatch(landingPageActions.openModalCpf(false))}
        onRedirectToLogin={onRedirectToLogin}
      />
    </BannerWrapper>
  )
}

export default Banner
